import React from "react";

import "../styles/bulma_loader.scss";

const Vereinsmeisterschaft2026 = () => {
  return (
    <div className="content is-size-5">
      <h1 className="title" id="vereinsmeisterschaft-2026">
        Vereinsmeisterschaft 2026
      </h1>

      <p>
        Von <strong>05.07.2026</strong> bis <strong>27.09.2026</strong> wird
        wieder die Vereinsmeisterschaft ausgetragen.
      </p>

      <div className="columns mt-4">
        <div className="column is-half">
          <h3 className="has-text-weight-semibold">Regelungen</h3>
          <p>
            Je Disziplin: <strong>20 Schuss</strong>
            <br />
            Ausnahme Taube: <strong>50 Tauben</strong>
          </p>

          <h3 className="has-text-weight-semibold mt-4">Anmeldung</h3>
          <p>
            Bitte meldet eure Teilnahme an der VMS bei der&nbsp;
            <strong>Standaufsicht</strong>&nbsp;an.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Vereinsmeisterschaft2026;
